import React from 'react';
import { CheckIcon } from 'lucide-react';
import { ACTION_CHECKLIST } from '../../data/roadmapContent';
import { formatDate, reviewDate } from '../../utils/roadmapCalcs';
interface ActionChecklistProps {
  checked: string[];
  onToggle: (id: string) => void;
}
export function ActionChecklist({
  checked,
  onToggle
}: ActionChecklistProps) {
  return <section className="rounded-3xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 shadow-sm dark:shadow-none p-6 sm:p-8" data-id="element-172" data-mp="1ytir8bac2tby">
      <h2 className="text-xl font-bold text-slate-900 dark:text-white" data-id="element-173" data-mp="28pvqdoondze3">
        Your action checklist
      </h2>
      <p className="mt-2 text-sm text-slate-500 dark:text-slate-400" data-id="element-174" data-mp="2dqjhsbgsgi8u">
        Tick these off as you go — they'll carry through to your PDF.
      </p>

      <ul className="mt-6 space-y-2" data-id="element-175" data-mp="2hoqzp9mznplm">
        {ACTION_CHECKLIST.map(item => {
        const isChecked = checked.includes(item.id);
        return <li key={item.id} data-id="element-176" data-mp="ndu15b1s9e6x">
              <label className="flex items-center gap-3 px-4 py-3.5 rounded-xl border border-slate-200 dark:border-white/10 hover:border-primary-400 dark:hover:border-primary-500/50 transition-colors cursor-pointer" data-id="element-177" data-mp="nf55pd31ypz3">
                <input type="checkbox" checked={isChecked} onChange={() => onToggle(item.id)} className="sr-only" data-id="element-178" data-mp="2ni4cy2ppf9ae" />
                <span className={`flex items-center justify-center w-6 h-6 flex-shrink-0 rounded-md border transition-colors ${isChecked ? 'bg-primary-500 border-primary-500' : 'border-slate-300 dark:border-white/20'}`} aria-hidden="true" data-id="element-179" data-mp="3g6s6elklx4z1">
                  {isChecked && <CheckIcon className="w-4 h-4 text-white" data-id="element-180" data-mp="1utfk0qysya9q" />}
                </span>
                <span className={`text-base ${isChecked ? 'text-slate-400 dark:text-slate-500 line-through' : 'text-slate-700 dark:text-slate-200'}`} data-id="element-181" data-mp="1urckngbrf4sc">
                  {item.label}
                </span>
              </label>
            </li>;
      })}
      </ul>

      <p className="mt-5 text-sm font-medium text-primary-600 dark:text-primary-400" data-id="element-182" data-mp="lu60j0kr0g5q">
        Review date: {formatDate(reviewDate())}
      </p>
    </section>;
}